var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RibbonButton',{class:['component--ribbon__check', _vm.isChecked ? 'checked' : null],attrs:{"size":_vm.size,"disabled":_vm.disabled,"label":_vm.label,"icon":_vm.icon,"iconClass":_vm.iconClass,"title":_vm.titleText},on:{"click":_vm.handleClick}},[(_vm.$slots.default)?_c('template',{slot:"icon"},[_vm._t("default")],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }